import { render, staticRenderFns } from "./ImageCapture.vue?vue&type=template&id=22f9d95c&scoped=true&"
import script from "./ImageCapture.vue?vue&type=script&lang=js&"
export * from "./ImageCapture.vue?vue&type=script&lang=js&"
import style0 from "./ImageCapture.vue?vue&type=style&index=0&id=22f9d95c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f9d95c",
  null
  
)

export default component.exports